module.exports = __webpack_public_path__ + "static/img/partner_VI.e703b15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_VI.png
// module id = 8Sq0
// module chunks = 9